import React from 'react'
import spinner from '../images/button-spinner.gif'

const ButtonSpinner = () => {
    return (
        <div>
            <img style={{ width: '25px', height: '25px' }} src={spinner} alt='Loading' />
        </div>
    )
}

export default ButtonSpinner